import {
    CONFIRMED_GET_DISEASES,
    CONFIRMED_CREATE_DISEASE,
    CONFIRMED_DELETE_DISEASE,
    CONFIRMED_EDIT_DISEASE,
  } from "../actions/DiseasesTypes"; // Make sure this import path and file match
  
  const initialState = {
    diseases: [],
    num_rows: 0,
  };
  
  export default function DiseaseReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_DISEASES:
        return {
          ...state,
          // diseases: action.payload,
          diseases: action.payload.diseases,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_DISEASE:
        return {
          ...state,
          diseases: [...state.diseases, action.payload],
        };
  
      case CONFIRMED_DELETE_DISEASE:
        return {
          ...state,
          diseases: state.diseases.filter(
            (disease) => disease.disease_id !== action.payload.disease_id
          ),
        };
  
      case CONFIRMED_EDIT_DISEASE:
        const updatedDiseases = [...state.diseases];
        const index = updatedDiseases.findIndex(
          (disease) => disease.disease_id === action.payload.disease_id
        );
  
        if (index !== -1) {
          updatedDiseases[index] = action.payload;
        }
  
        return {
          ...state,
          diseases: updatedDiseases,
        };
  
      default:
        return state;
    }
  }
  